import * as React from 'react';

var _path, _path2, _path3, _path4;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function SvgCheese(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 290 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.583 126.875c0-13.111 10.452-23.72 23.471-24.095-.767-25.532-1.903-47.874-1.903-47.874-97.125 8.005-195 27.858-195 27.858-12.996 2.574-15.6 5.148-18.198 15.425 0 0-5.202 20.56 2.598 64.259s36.474 61.697 49.397 61.697c0 0 105.819 9.963 161.203 2.912 0 0 2.187-41.385 2.55-76.022-13.328-.03-24.118-10.833-24.118-24.16z",
    fill: "#FFE57F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.079 212.382l-.568-.054h-.568c-6.006 0-30.686-12.978-37.64-51.94-7.129-39.954-2.791-59.251-2.767-59.348.906-3.594 1.432-4.495 1.45-4.555.278-.205 1.656-.99 7.558-2.15.925-.188 90.051-18.15 181.244-26.578l11.92-.955c-.326-7.304-.562-11.896-.562-11.896-97.125 8.005-195 27.858-195 27.858-12.996 2.574-15.6 5.148-18.198 15.425 0 0-5.202 20.56 2.598 64.259s36.48 61.697 49.403 61.697c0 0 57.758 5.438 110.26 5.438 18.56 0 36.474-.683 50.944-2.525 0 0 .247-4.749.598-12.368-14.5 1.867-38.691 3.081-51.536 3.081-51.312 0-108.563-5.334-109.136-5.389z",
    fill: "#FFB300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.035 103.886c.441-3.801.913-5.698.913-5.698 2.598-10.277 5.196-12.85 18.197-15.424 0 0 97.875-19.853 195.001-27.858 0 0-81.297-4.157-98.963-5.885-17.665-1.728-33.102 0-41.802 2.707-8.706 2.7-37.084 14.512-37.084 14.512C34.3 81.302 37.03 103.886 37.035 103.886z",
    fill: "#FFA000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.917 157.083c13.347 0 24.166-10.819 24.166-24.166s-10.819-24.167-24.166-24.167-24.167 10.82-24.167 24.167c0 13.347 10.82 24.166 24.167 24.166zM199.374 108.751c6.674 0 12.084-5.41 12.084-12.084 0-6.673-5.41-12.083-12.084-12.083-6.673 0-12.083 5.41-12.083 12.083 0 6.674 5.41 12.084 12.083 12.084zM99.687 193.333c8.342 0 15.104-6.762 15.104-15.104 0-8.342-6.762-15.104-15.104-15.104-8.342 0-15.104 6.762-15.104 15.104 0 8.342 6.762 15.104 15.104 15.104zM75.52 138.959a9.062 9.062 0 009.063-9.063 9.062 9.062 0 00-9.063-9.062 9.062 9.062 0 00-9.062 9.062 9.062 9.062 0 009.063 9.063zM199.375 187.293c10.01 0 18.125-8.115 18.125-18.125s-8.115-18.125-18.125-18.125-18.125 8.115-18.125 18.125 8.115 18.125 18.125 18.125z",
    fill: "#FFC400"
  })));
}

export { SvgCheese as default };